import React from 'react';
import './simpleloader.scss';

export default function SimpleLoader() {
    return (
        <div className="simple-loader-wrapper">
            <div className="simple-loader-ring"></div>
        </div>
    );
}
